export default __webpack_public_path__ + "../staticImages/tandem-260.png";